import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {UtilitiesService} from "../../../common/service/utilities.service";
import {NavItem} from "../nav.model";

@Component({
  selector: 'app-nav-item, [app-nav-item], .app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent implements OnInit {

  @Input() item;
  @Input() actionsOn :boolean = true; // true, false
  @Input() isMobile :boolean = false; // true, false
  @Output() componentAction:EventEmitter<string> = new EventEmitter<string>();

  target: string;
  cssClass: string;
  title: string;
  haveChildren: boolean;
  children;
  route;
  cssActive: string;

  constructor( private router: Router,
               private util:UtilitiesService ) {
    console.log("new item added")

  }

  ngOnChanges(){
    if (this.item) {
      this.target = (this.item.newWindow) ? "_blank" : "_self";
      this.cssClass = (this.item.cssClass) ? " " + this.item.cssClass.trim() : "";
      this.title = this.item.title.trim();
      this.haveChildren = this.item.children.length > 0;
      this.children = this.item.children;
      this.route = (this.item.component) ? (this.item.component) :
            (this.item.url) ? this.item.url : "";
      if (this.isMobile) this.cssClass = this.cssClass + " ropdown-toggle";
    }

    if (this.route == this.router.url) this.cssActive = "active";
    else this.cssActive = "";
  }

  ngOnInit() {
  }

  goTo(): void {
    // TODO:
    if (this.item.component) {
      if (this.actionsOn){
        this.componentAction.next(this.item.component);
      } else {
        this.util.goTo(this.item.url);
      }
    } else if (this.item.url) {
      // window.location.href = this.item.url.toString();
        this.util.goTo(this.item.url);
    }
  }

  orederNav( items: NavItem[] ){
    if (items.length > 0 ){
      return items.sort((a, b) => {return a.order - b.order});
    }
  }

}
